import React from 'react';

import {alertActions} from '../../user-manager';
import {HistoryManager} from '../../history-manager';
import {ModelManager} from "../../model-manager";
import {SessionManager} from "../../session-manager";
import {ElementForm, Input} from "../../form-component";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";

class ResetPasswordForm extends ElementForm {
    constructor(props) {
        const element = {
            '@id': '/api/request_password_histories',
            plainPassword: '',
            repeatPassword: '',
            requestedAt: null,
            email: null,
        };

        super(props, element);

        this.getRequestPasswordHistory = this.getRequestPasswordHistory.bind(this);

    }

    componentDidMount() {
        this.getRequestPasswordHistory();
    }

    getRequestPasswordHistory() {
        this.setState({isLoading: true});

        ModelManager.fetchList("/api/request_password_histories", { token: this.props.token }, true)
            .finally(() => {
                this.setState({isLoading: false});
            })
            .then(res => {
                if (res.getCount() === 0) {
                    throw new Error("Element not found");
                }

                const element = res.getMembers()[0];
                element.plainPassword = '';
                element.repeatPassword = '';
                this.setState({element});
            })
            .catch(() => {
                this.setState({error: true});
            });
    }

    submit(e) {
        e.preventDefault();

        const {dispatch} = this.props;


        let violations = [];

        if (this.state.element.plainPassword === '') {
            violations.push({propertyPath: 'plainPassword', message: 'Le mot de passe est obligatoire.'});
        }

        if (this.state.element.plainPassword !== this.state.element.repeatPassword) {
            violations.push({propertyPath: 'plainPassword', message: 'Les mots de passe ne correspondent pas.'});
        }

        if (violations.length === 0) {
            ModelManager.save(this.state.element).then((element) => {
                this.setState({element});
                HistoryManager.getHistory().push(SessionManager.isAuthenticated() ? '/user/profile' : '/login');
                dispatch(alertActions.success('Votre mot de passe a été changé.'));
            }).catch(error => {
                error.violations ? this.mapErrors(error.violations) : this.cleanErrors();
            });
        } else {
            this.mapErrors(violations);
        }
    }

    render() {
        return (
            <div className="change-password page">
                <div className="title">Changer mon mot de passe</div>
                {false === this.state.isLoading ?
                    <div>
                        {this.state.error ? <p>Token introuvable</p> :
                            <form noValidate className="ajax-contact-form">
                                <div className="form-row">
                                    <div className="form-group col-md-12">
                                        <Input name="plainPassword" label="Mot de passe"
                                               type="password"
                                               value={this.state.element.plainPassword}
                                               errors={this.state.errors.plainPassword}
                                               updateElement={this.updateElement}
                                               required={true}/>

                                        <Input name="repeatPassword" label="Mot de passe (confirmation)"
                                               type="password"
                                               value={this.state.element.repeatPassword}
                                               errors={this.state.errors.repeatPassword}
                                               updateElement={this.updateElement}
                                               required={true}/>
                                    </div>
                                </div>


                                <div className="form-group">
                                    <div className="col-md-6">
                                        <Link to="/login" className="btn btn-link btn-block">Se connecter</Link>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="submit" onClick={this.submit} className="submit btn btn-info btn-block">Valider</button>
                                    </div>
                                </div>

                                <div className="span12">
                                    <small className="form-text text-muted">
                                        (*) Champs requis.
                                    </small>
                                </div>
                            </form>
                        }
                    </div> : <div className="loading"><img src="/loading.gif" alt="loading"/></div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

const ConnectedResetPasswordForm = connect(mapStateToProps)(ResetPasswordForm);
export {ConnectedResetPasswordForm as ResetPasswordForm};